<template>
  <div>
    <v-dialog
      v-model="model"
      v-bind:content-class="userSectionClass"
      transition="dialog-bottom-transition"
      max-width="700px"
    >
      <v-sheet class="text-center vetalfa-padding-bottom-notch">
        <v-row aling="center" justify="start" class="pa-0 ma-0 pl-2 pt-2">
          <v-btn
            x-small
            @click="close()"
            text
            class="text-none primary--text"
            style="border: 0.5px solid rgba(242, 242, 242, 1)"
          >
            {{ _getLabel("CLOSE") }}
          </v-btn>
        </v-row>
        <v-row class="ma-0 pa-0 pt-2">
          <v-list style="width: 100%">
            <v-list-item @click="accountsRedirect">
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="16px" tile>
                  <v-icon color="primary">{{ _icon("account") }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left font-weight-normal">{{
                _getLabel("MY_DATA")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="subscriptionsOptionClick">
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18px" tile>
                  <v-icon color="primary">{{ _icon("pro") }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                !!isPremium ? _getLabel("MY_SUBSCRIPTION") : _getLabel("VA_PRO")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="contactUsClick">
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18px" tile>
                  <v-icon color="primary">{{ _icon("support") }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("USER_SECTION_CONTACT_US")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="displayHelpCenterClick">
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18px" tile>
                  <v-icon color="primary">{{ mdiHelpCircleOutline }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("HELP_CENTER")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              @click="
                () => {
                  openExternalUrl({
                    url: _getParameter('HOME_URL'),
                    inAppBrowser: true,
                  });
                  model = false;
                }
              "
            >
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18px" tile>
                  <v-icon color="primary">{{ _icon("about") }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("ABOUT")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              @click="
                () => {
                  openExternalUrl({
                    url: _getParameter('TERMS_URL'),
                    inAppBrowser: true,
                  });
                  model = false;
                }
              "
            >
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="12px" tile>
                  <v-icon color="primary">{{ _icon("terms") }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("USE_TERMS_TITLE")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              @click="
                () => {
                  openExternalUrl({
                    url: _getParameter('POLICIES_URL'),
                    inAppBrowser: true,
                  });
                  model = false;
                }
              "
            >
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18" tile>
                  <v-icon color="primary">{{ mdiShieldLock }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("PRIVACY_POLICIES_TITLE")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              @click="
                () => {
                  confirmLogout();
                  model = false;
                }
              "
            >
              <v-list-item-avatar class="ma-0 pa-0 mr-4">
                <v-avatar size="18px" tile>
                  <v-icon color="primary">{{ mdiExitToApp }}</v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title class="text-left">{{
                _getLabel("USER_SECTION_LOGOUT")
              }}</v-list-item-title>
              <v-list-item-action>
                <v-icon small color="primary">
                  {{ mdiChevronRight }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <v-row class="ma-0 pa-0 mt-2" align="center" justify="end">
          <p
            class="ma-0 term-form-app-version vetalfa-padding-bottom-notch text-right"
          >
            {{ _getParameter("APP_VERSION") }}
          </p>
        </v-row>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<style>
.term-form-app-version {
  font-size: 10px;
  padding-bottom: calc(24px + env(safe-area--top));
  padding-right: 12px;
  padding-left: 20px;
}
.term-form-text {
  font-size: 14px !important;
  text-align: justify !important;
}
</style>

<script>
import {
  mdiExitToApp,
  mdiShieldLock,
  mdiEmailOutline,
  mdiInstagram,
  mdiChevronRight,
  mdiHelpCircleOutline,
} from "@mdi/js";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "UserSection",
  components: {},
  props: {},
  methods: {
    ...mapMutations("general", ["setUserSection"]),
    ...mapActions("general", [
      "openExternalUrl",
      "confirmLogout",
      "contactUs",
      "displayHelpCenter",
      "logEvent",
      "routeRedirect",
    ]),
    contactUsClick() {
      this.model = false;
      this.contactUs();
    },
    displayHelpCenterClick() {
      this.model = false;
      this.displayHelpCenter();
    },
    ...mapActions("purchases", [
      "openPurchasesFromMenu",
      "purchasesManageSubscriptions",
    ]),
    accountsRedirect() {
      this.model = false;
      this.routeRedirect({ name: "accounts" });
    },
    clickOpenPurchases() {
      this.$nextTick(() => {
        this.model = false;
      });
      this.openPurchasesFromMenu();
    },
    clickManageSubscriptions() {
      this.logEvent("purchasesManageSubscriptions");
      this.$nextTick(() => {
        this.model = false;
      });
      this.purchasesManageSubscriptions();
    },
    subscriptionsOptionClick() {
      if (this.isPremium) {
        this.clickManageSubscriptions();
      } else {
        this.clickOpenPurchases();
      }
    },
    close() {
      this.model = false;
    },
  },
  watch: {},
  computed: {
    ...mapGetters("general", [
      "userSection",
      "user",
      "isPremium",
      "entitlements",
    ]),
    model: {
      get() {
        return !!this.userSection;
      },
      set(val) {
        this.setUserSection(val);
      },
    },
    height() {
      return window.innerHeight;
    },
    userSectionClass() {
      return this.$vuetify.breakpoint.xsOnly ? "v-bottom-sheet" : "";
    },
  },
  data() {
    return {
      mdiExitToApp,
      mdiShieldLock,
      mdiEmailOutline,
      mdiInstagram,
      mdiChevronRight,
      mdiHelpCircleOutline,
    };
  },
};
</script>